import { createSelector } from 'reselect';

const selectClaimsData = (state) => state.getIn(['getClaims']);
const selectGWClaimsData = (state) => state.getIn(['getGWClaims']);
const selectCreatedClaim = (state) => state.getIn(['createClaim']);
const selectCreatedShellClaim = (state) => state.getIn(['createShellClaim']);
const selectUpdatedClaim = (state) => state.getIn(['updateClaim']);
const selectSubmitedClaim = (state) => state.getIn(['submitClaim']);

export const claimsDataSelector = createSelector(selectClaimsData, (claimsData) => claimsData.toJS());
export const gwClaimsDataSelector = createSelector(selectGWClaimsData, (gwClaimsData) => gwClaimsData.toJS());
export const selectCreatedClaimSelector = createSelector(selectCreatedClaim, (createClaim) => createClaim.toJS());
export const selectCreatedShellClaimSelector = createSelector(selectCreatedShellClaim, (createShellClaim) => createShellClaim.toJS());
export const selectUpdatedClaimSelector = createSelector(selectUpdatedClaim, (createClaim) => createClaim.toJS());
export const selectSubmitedClaimSelector = createSelector(selectSubmitedClaim, (createClaim) => createClaim.toJS());
